<template>
  <article>
    <div id="PAYMENT_TRANSACTIONS" class="container-fixed offset-bottom-4">
      <VFilter @update="onFilterUpdate" />
    </div>
    <div v-if="validRows" class="container-fluid grayed-offset">
      <div class="container-fixed">
        <VList :rows="rows" @select="onSelect" />
      </div>
    </div>
    <div class="container-fixed">
      <VDetails :entry="entry" @update="onDetailsUpdate" />
    </div>
  </article>
</template>

<script>
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import { dateTimeInputFormat, dateUrlFormat } from '@/utils/date';
import { PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS } from '@route-types';
import TitleMixin from '@/mixins/title';
import VFilter from './Filter';
import VList from './List';
import VDetails from './Details';

export default {
  name: 'PaymentTransactions',

  components: {
    VFilter,
    VList,
    VDetails,
  },

  mixins: [TitleMixin],

  data() {
    return {
      rows: null,
      entry: null,
    };
  },

  computed: {
    validRows() {
      return this.rows && this.rows.length;
    },
  },

  created() {
    this.$webtrekk.viewPage('bezahltransaktionen', 'basket');
  },

  methods: {
    onSelect(row) {
      this.entry = row;
    },

    onFilterUpdate(response) {
      this.rows = response;
    },

    onDetailsUpdate(response) {
      if (!this.$route.params.from || !this.$route.params.to) {
        // if list is not loaded (e.g. deeplink from contractSearch)
        const from = format(parse(response.start, dateTimeInputFormat, new Date()), dateUrlFormat);
        const to = from;
        const { transactionId, tab } = this.$route.params;
        this.$router.push({
          name: PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS,
          params: { from, to, transactionId, tab },
        });
      }
    },
  },
};
</script>
